import { useFlags } from 'launchdarkly-react-client-sdk';

import { Section, SectionTitle, StatusItem, StatusValue } from './styles';

import { useAppSelector } from 'features/app/hooks';
import { sipCallIdSelector } from 'features/call/call-base/store/selectors';
import { selectCallPageStatus } from 'features/call/call-ui-state/store';
import { trainingForkerSelector } from 'features/training-forker/store';
import {
  selectCallerSessionId,
  selectCallerSessionStatus,
} from 'features/caller-session/store';
import { selectVideoRenderingStatus } from 'features/remote-media/store';

export const SessionTab = () => {
  const callerSessionStatus = useAppSelector(selectCallerSessionStatus);
  const callerSessionId = useAppSelector(selectCallerSessionId);
  const sipCallId = useAppSelector(sipCallIdSelector);
  const callPageStatus = useAppSelector(selectCallPageStatus);
  const videoDetectionStatus = useAppSelector(selectVideoRenderingStatus);
  const trainingForkerState = useAppSelector(trainingForkerSelector);
  const { enableTrainingForking } = useFlags();

  return (
    <>
      <Section>
        <SectionTitle variant='subtitle2'>Session Information</SectionTitle>
        <StatusItem>
          Session Status: <StatusValue>{callerSessionStatus}</StatusValue>
        </StatusItem>
        <StatusItem>
          Call Page Status: <StatusValue>{callPageStatus}</StatusValue>
        </StatusItem>
        <StatusItem>
          Caller Session ID: <StatusValue>{callerSessionId}</StatusValue>
        </StatusItem>
        <StatusItem>
          SIP Call ID: <StatusValue>{sipCallId}</StatusValue>
        </StatusItem>
        <StatusItem>
          Video Rendering Status:
          <StatusValue>{videoDetectionStatus ?? 'Unknown'}</StatusValue>
        </StatusItem>
      </Section>

      <Section>
        <SectionTitle variant='subtitle2'>Training Forker</SectionTitle>
        <StatusItem>
          Forker Enabled:{' '}
          <StatusValue>
            {enableTrainingForking ? 'Yes' : 'No'} (LaunchDarkly flag)
          </StatusValue>
        </StatusItem>
        <StatusItem>
          Forker Allowed:{' '}
          <StatusValue>
            {trainingForkerState.enabled
              ? 'Yes (All conditions met)'
              : 'No (Some conditions not met)'}
          </StatusValue>
        </StatusItem>
        <StatusItem>
          Forker Active:{' '}
          <StatusValue>{trainingForkerState.active ? 'Yes' : 'No'}</StatusValue>
        </StatusItem>
      </Section>
    </>
  );
};
